import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { connect } from 'react-redux';
import { IDType } from '../../../config/types';
import {
  CardEvent,
  ChangeEvent,
  GoalEvent,
  Lineup,
  TeamListElement,
  MatchLocationEnum
} from "../../../client/api";
import { RootState } from "../../../store";
import { getLineupOfMatch } from "../../../store/actions/matchActions";

const props = (
  state: RootState,
  prevProps: {
    team1Id: IDType;
    team1: TeamListElement;
    team2Id: IDType;
    team2: TeamListElement;
    matchId: IDType;
    lineup1: Lineup | undefined;
    lineup2: Lineup | undefined;
    cardEvents: CardEvent[];
    goalEvents: GoalEvent[];
    changeEvents: ChangeEvent[];
    playerRatings?: Record<string, (number | null)>;
  },
) => ({
  loading: state.match.status === 'loading',
  ...prevProps,
});

const mapper = (dispatch: ThunkDispatch<any, any, AnyAction>) => ({
  fetchLineup: (matchId: IDType, which: MatchLocationEnum) =>
    getLineupOfMatch(dispatch, matchId, which),
});

export const connector = connect(props, mapper);
